<template>
  <div class="breadCrumbs-options-style">
    <local-style
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="cxBreadCrumbs"
      :styleImgs="request_prefix === 'bigScreen'? styleImages: styleImagesHome"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "breadCrumbs-options-style",
  components: {localStyle},
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeIndex: undefined,
      activeNames: [],
      showLen: 6,
      styleImages: [],
      styleImagesHome: [
        require("../../../assets/images/leftMenu/breadCrumbs/style1.png"),
        require("../../../assets/images/leftMenu/breadCrumbs/style2.png")
      ]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.button-styles {
  justify-content: space-between;
  flex-wrap: wrap;
  .button-style-item {
    // min-width: 33%;
    width: calc((100% - 16px) / 3);
    margin: 0 4px 12px;
    box-sizing: border-box;
    border-radius: 4px;
    // border: 1px solid #e9e9e9;
    text-align: center;
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .img-style-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
      }
    }
    .img-style-box {
      height: 53px;
      line-height: 53px;
      border-radius: 4px;
      margin-bottom: 8px;
      background-color: var(--styleBgColor);
      border: 1px solid var(--styleBgColor);
    }
  }
  .button-item {
    width: 100%;
    border: none;
    padding: 0;
  }
}
</style>
